/**
 * 벤더 이름 서비스
 * vendor_master API에서 이름을 가져오고, 실패 시 하드코딩 fallback 사용
 * Created: 2025-09-22 12:40:00 KST
 */

import { providerNames } from '../utils/providerUtils';

class VendorNameService {
  constructor() {
    this.apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5101';
  }

  /**
   * 벤더 이름 매핑 가져오기 (캐싱 없음, 항상 최신 데이터)
   * @param {boolean} forceRefresh - 강제 새로고침 여부
   * @returns {Promise<Object>} 벤더 코드별 이름 매핑
   */
  async getVendorNames(forceRefresh = false) {
    // 캐싱 없이 항상 API 호출 (새로고침 버튼 클릭 시에만 호출되도록 구현)

    try {
      // API 호출
      const response = await fetch(`${this.apiUrl}/vendor-names/mapping`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        // 3초 타임아웃 설정
        signal: AbortSignal.timeout(3000)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success && result.data) {
        console.log('[VendorNameService] Successfully fetched vendor names from API');

        // API 데이터와 하드코딩 데이터 병합 (API 우선)
        const mergedData = { ...providerNames };

        Object.keys(result.data).forEach(code => {
          const lowerCode = code.toLowerCase();
          mergedData[lowerCode] = result.data[code].ko || result.data[code].en;
        });

        return mergedData;
      } else {
        throw new Error('Invalid API response format');
      }
    } catch (error) {
      console.warn('[VendorNameService] Failed to fetch from API, using fallback:', error.message);

      // API 실패 시 하드코딩된 데이터 사용
      return providerNames;
    }
  }

  /**
   * 특정 벤더의 한글 이름 가져오기
   * @param {string} vendorCode 벤더 코드
   * @returns {Promise<string>} 한글 이름
   */
  async getVendorNameKo(vendorCode) {
    const names = await this.getVendorNames();
    const lowerCode = vendorCode.toLowerCase();

    return names[lowerCode] || vendorCode;
  }

  // 캐시 기능 제거됨 - 새로고침 시에만 API 호출
}

// 싱글톤 인스턴스
const vendorNameService = new VendorNameService();

export default vendorNameService;